/** Tags the editor produces. `b`/`i` are accepted on the way in and rewritten to strong/em. */
export const EDITOR_VOCABULARY = new Set([
  "p", "br", "strong", "em", "ul", "ol", "li", "a", "b", "i",
]);
